import './SettingsPanel.css';

import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import SettingsPanelItemResolver from '../SettingsPanelItemResolver/SettingsPanelItemResolver';
import { createFormItemsMap } from '../../../../../utils/formItems/createFormItemMap';
import { normalizeFormItemMap } from '../../../../../utils/formItems/normalizeFormItemMap';
import {
  Dataset,
  FormItem,
  FullscreenReferenceType,
  GridInputValue,
  JSONObject,
  LayoutInlineForm,
} from '../../../../../types/types';
import { LayoutHandlerScope } from '../../../../../types/context';

interface SettingsPanelProps {
  form: LayoutInlineForm;
  data: JSONObject;
  referenceDatasets: Record<string, Dataset>;
  setReferenceDatasets: Dispatch<SetStateAction<Record<string, Dataset>>>;
  disabledFields?: string[];
  getFieldSaveError?: (name: string) => string | null;
  handlerScope?: LayoutHandlerScope;
  onFieldChange: (name: string, value: GridInputValue) => void;
  onFieldDefault?: (name: string, value: GridInputValue) => void;
  onFieldFocus?: (name: string) => void;
  onFieldBlur?: (name: string) => void;
  onOpenFullscreenReference?: (reference: FullscreenReferenceType) => void;
}

const SettingsPanel: FC<SettingsPanelProps> = ({ form, data, ...shared }) => {
  const nodes = useMemo<unknown[]>(() => {
    try {
      return normalizeFormItemMap(
        createFormItemsMap(form.items, form.groups, form.sections)
      );
    } catch (error) {
      // An item references an undefined group/section — dataset forms throw,
      // the editor degrades to the flat render.
      console.warn('[layout-editor] invalid form groups/sections', error);
      return form.items;
    }
  }, [form]);

  return (
    <div className="settings-panel">
      {nodes.map((node, index) => (
        <SettingsPanelItemResolver
          key={`${(node as FormItem).name ?? 'node'}_${index}`}
          node={node}
          form={form}
          data={data}
          {...shared}
        />
      ))}
    </div>
  );
};

export default SettingsPanel;
